module.exports = __webpack_public_path__ + "img/shield-plus.ab0d21ba.svg";